import { render, staticRenderFns } from "./resources-edit.vue?vue&type=template&id=1eaa083e&scoped=true"
import script from "./resources-edit.vue?vue&type=script&lang=js"
export * from "./resources-edit.vue?vue&type=script&lang=js"
import style0 from "./resources-edit.vue?vue&type=style&index=0&id=1eaa083e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eaa083e",
  null
  
)

export default component.exports